import { Resources } from './resources'

class PagesResource extends Resources {
  savePageItem ( pageId, data ) {
    return this.http.post( `${this.baseUrl}/${pageId}/items`, data )
  }
  updatePageItem ( pageId, data, id ) {
    return this.http.put( `${this.baseUrl}/${pageId}/items/${id}`, data )
  }
  deletePageItem ( pageId, id ) {
    return this.http.delete( `${this.baseUrl}/${pageId}/items/${id}` )
  }
  clonePage ( pageId, data ) {
    return this.http.post( `${this.baseUrl}/${pageId}/clone`, data )
  }
}
export default new PagesResource( 'pages' )


// WEBPACK FOOTER //
// ./src/resources/pages.js